<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>

      <div class="margin b15">

      <el-button type="primary"
                 size="small"
                 @click="$router.push({name: '新增邮件'})">新增邮件
      </el-button>
      </div>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="name"
                         label="名称"
                         min-width="120"></el-table-column>
        <el-table-column prop="type"
                         label="类别"
                         min-width="120">
          <template slot-scope="scope">
          <span v-for="item in options.type"
                v-if="scope.row.type === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updated_at"
                         label="更新时间"
                         min-width="120">
          <template slot-scope="scope">
            <el-button type="text"
                       @click="$router.push({name: '修改日志', params: {id: scope.row.id}})">
              {{scope.row.updated_at}}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column prop="status"
                         label="状态"
                         min-width="90">
          <template slot-scope="scope">
          <span v-for="item in options.status"
                v-if="scope.row.status === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <el-button type="text"
                       size="mini"
                       @click="$router.push({name: '查看满意度邮件', params: {id: scope.row.id}})">
              查看
            </el-button>

            <el-button type="text"
                       size="mini"
                       @click="$router.push({name: '修改满意度邮件', params: {id: scope.row.id}})">
              修改
            </el-button>

            <el-button type="text"
                       size="mini"
                       @click="$router.push({name: '推送记录', params: {id: scope.row.id}})">
              推送记录
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

  </div>
</template>

<script>
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'

export default {
  mixins: [table, dateTimePicker],
  components: {},
  data () {
    return {}
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.satisfactionEmail.options,
    }),
  },
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      params = filter.copyJson(params)
      return request.page('getSatisfactionEmailTable', params)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/satisfaction-email/pages/SatisfactionEmailTable.vue